<template>
  <div class="modal fade create-payment-method-modal" id="CreatePaymentMethodModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar método de pagamento</h1>
                  <button type="button" class="btn-close create-payment-method-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreatePaymentMethod" @submit.prevent="createPaymentMethodFunction">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar um método de pagamento</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_payment_method" class="form-label fw-medium">Nome do método</label>
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_payment_method"
                      placeholder="Ex: Cartão de crédito, Pix, Dinheiro"
                      autocomplete="off"
                      v-model="payment_method_name"
                      required
                    />
                  </div>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="fee_payment_method" class="form-label fw-medium">Taxa (%)</label>
                    <input
                      type="number"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="fee_payment_method"
                      placeholder="Ex: 2.5"
                      autocomplete="off"
                      v-model.number="payment_method_fee"
                      step="0.01"
                      min="0"
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="active_payment_method"
                        v-model="payment_method_active"
                      />
                      <label class="form-check-label" for="active_payment_method">
                        Ativar este método de pagamento
                      </label>
                    </div>
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreatePaymentMethod" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreatePaymentMethod"></div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger create-payment-method-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonCreatePaymentMethod" class="btn btn-success">Criar método</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';

export default {
  name: "CreatePaymentMethodModal",
  data() {
    return {
      payment_method_name: "",
      payment_method_fee: null,
      payment_method_active: true
    }
  },
  methods: {
    createPaymentMethodFunction() {
      const alertResponse = this.alertResponse;

      if (this.payment_method_name === "") {
        this.alertResponse("Por favor preencha o nome do método de pagamento", true);
        return;
      }

      const objPaymentMethodCreate = {
        "name": this.payment_method_name,
        "fee": this.payment_method_fee || 0,
        "active": this.payment_method_active
      }

      const buttonCreatePaymentMethod = this.$refs.buttonCreatePaymentMethod;
      buttonCreatePaymentMethod.disabled = true;
      buttonCreatePaymentMethod.innerHTML = "Criando método...";
      
      api.axios.post("/api/payment-methods/create", objPaymentMethodCreate).catch(function(error) {
        buttonCreatePaymentMethod.disabled = false;
        buttonCreatePaymentMethod.innerHTML = "Criar método";
        console.log("error", error);
        if (error.response && error.response.data) {
          alertResponse(error.response.data.message || "Erro ao criar método de pagamento", true);
        } else {
          alertResponse("Erro ao criar método de pagamento", true);
        }
      }).then(function(response) {
        if (response !== undefined && response.status == 200) {
          buttonCreatePaymentMethod.innerHTML = "Método criado com sucesso!";
          window.location.reload();
        } else {
          buttonCreatePaymentMethod.disabled = false;
          buttonCreatePaymentMethod.innerHTML = "Criar método";
        }
      });
    },
    alertResponse(message, error) {
      const warningMessage = `<i class="flaticon flaticon-warning"></i> ` + message;
      const successMessage = `<i class="flaticon flaticon-check"></i> ` + message;
      
      if (error) {
        document.getElementById("errorMessageCreatePaymentMethod").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreatePaymentMethod").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreatePaymentMethod");
      if (elementAlert) {
        if (error) {
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>
